/* unplugin-vue-components disabled */import { render } from "./NewsInformation.vue?vue&type=template&id=f874e70e&scoped=true"
import script from "./NewsInformation.vue?vue&type=script&lang=js"
export * from "./NewsInformation.vue?vue&type=script&lang=js"

import "./NewsInformation.vue?vue&type=style&index=0&id=f874e70e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f874e70e"]])

export default __exports__